import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { CloseIcon } from '../../../icons';
import * as PropTypes from 'prop-types';
var ModalBody = /** @class */ (function (_super) {
    __extends(ModalBody, _super);
    function ModalBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalBody.prototype.render = function () {
        var _a = this, context = _a.context, props = _a.props;
        var hideCloseButton = context.hideCloseButton, modalHasHeader = context.modalHasHeader, onDismiss = context.onDismiss;
        var paddingClass = props.forceNoPadding ? 'no-padding' : '';
        var className = namespacedClassnames('modal-body', paddingClass, props.className || '');
        var shouldAddCloseButton = !hideCloseButton && !modalHasHeader && !!onDismiss;
        var maybeCloseButton = (shouldAddCloseButton) && (React.createElement("div", { className: 'close-button-container' },
            React.createElement("div", { className: 'close-btn', onClick: onDismiss },
                React.createElement(CloseIcon, null))));
        return (React.createElement("div", { className: className },
            maybeCloseButton,
            props.children));
    };
    ModalBody.contextTypes = {
        modalHasHeader: PropTypes.bool,
        onDismiss: PropTypes.func,
        hideCloseButton: PropTypes.bool
    };
    return ModalBody;
}(React.PureComponent));
export { ModalBody };
//# sourceMappingURL=modal-body.js.map